module.exports = "./img/069cec612c99f05f46c0c0422bdb6100.jpg";